import React, {ReactNode} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {Modal} from "react-bootstrap";
import {RootState} from "../../../../../reducers";

interface OwnProps {
    children?: ReactNode;
    image: any;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const MenuItemBaseModalComponent = (props: Props) => {
    const {t} = useTranslation();

    return (
        <Modal dialogClassName="modal-full modal-product modal-product-full" show aria-labelledby="menu_item_base_modal_title">
            <div className={"container-fluid"}>
                <div className={"row"}>
                    <div className={"col-md-6"}>
                        {props.image && (
                            <div className="product-item-img">
                                <img src={props.image} alt={t("common.word.product_image")}/>
                            </div>
                        )}
                    </div>
                    <div className={"col-md-6 modal-product-full-right"}>
                        {props.children}
                    </div>
                </div>
            </div>
        </Modal>
    )
}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuItemBaseModalComponent));